import './App.css';
import Header from './Header';
import Intro from './Intro';
import About from './About';
import Skills from './Skills';
import Projects from './Projects'
import backgroundVideo from './170480-843367912.mp4';

function App() {
  return (
    <div className="App">
      <div className = "background">
        <video 
          autoPlay 
          loop 
          muted 
          playsInline
          className="background-video"
        >
          <source src={backgroundVideo} type="video/mp4" />
        </video>
      </div>
      <div className = "header">
        <Header />
      </div>
    
      {/* Intro hero */}
      <Intro />

  <section id="about">
    <About />
  </section>
  
  <section id="skills">
    <Skills />
  </section>

  <section id="projects">
    <Projects />
  </section>


 
      
    </div>
  );
}

export default App;
